import * as tslib_1 from "tslib";
export default function convertReadWriteRecipientToRecipientPersonaProps(readWriteRecipients) {
    if (readWriteRecipients) {
        var recipientPersonaProps = readWriteRecipients.map(function (obj) {
            var recipientPersonaProp = tslib_1.__assign({ primaryText: obj.persona.EmailAddress.Name }, obj);
            return recipientPersonaProp;
        });
        return recipientPersonaProps;
    }
    else {
        return [];
    }
}
//# sourceMappingURL=convertReadWriteRecipientToRecipientPersonaProps.js.map